import { render, staticRenderFns } from "./app-block-flex.vue?vue&type=template&id=3587473e&scoped=true&"
import script from "./app-block-flex.vue?vue&type=script&lang=js&"
export * from "./app-block-flex.vue?vue&type=script&lang=js&"
import style0 from "./app-block-flex.vue?vue&type=style&index=0&id=3587473e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3587473e",
  null
  
)

export default component.exports